import { default as BSTooltip } from 'bootstrap/js/src/tooltip'

class Tooltip extends BSTooltip {}

export default Tooltip
